import { useState } from 'react'

export const useDialog = () => {
  const [showDialog, setShowDialog] = useState(false)
  const handleShowDialog = () => setShowDialog(true)
  const handleHideDialog = () => setShowDialog(false)

  return { showDialog, handleShowDialog, handleHideDialog }
}
